<template>
  <!-- <v-pagination
      v-model="page"
      :length="5"
      prev-icon="mdi-menu-left"
      next-icon="mdi-menu-right"
  ></v-pagination>-->
  <v-pagination
    v-model="pagination.page"
    :length="pages"
    @input="next"
    :total-visible="7"
    prev-icon="mdi-menu-left"
    next-icon="mdi-menu-right"
  ></v-pagination>
</template>

<script>
export default {
  name: "pagination",
  props: {
    pageNum: Number,
    perPage: Number,
    totalCount: Number,
  },
  data() {
    return {
      pageSkip: Number,
      pagination: {
        page: 1,
      },
    };
  },
  watch: {
    pageNum() {
      this.pagination.page = this.pageNum;
    },
  },
  computed: {
    pages() {
      return this.perPage ? Math.ceil(this.totalCount / this.perPage) : 1;
    },
  },
  methods: {
    next() {
      this.$emit("pageSkip", this.pagination.page);
    },
  },
};
</script>
